import React, { useEffect } from "react";

import MasterBankTable from "./MasterBankTable";
import MasterBankAdd from "./MasterBankAdd";
import MasterBankEdit from "./MasterBankEdit";

import Breadcrumbs from "../../../components/ui/Breadcrumbs";

import useApiNew from "../../../utils/useApiNew";
import axios from "axios";

import DeleteAlert from "../../../components/ui/DeleteAlert";

import { errorNotify, successNotify } from "../../../Services/Notification";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const bankApiURL = `${process.env.REACT_APP_API_URL}api/bank`;
const exportBankApiURL = `${process.env.REACT_APP_API_URL}api/export-bank`;

const MasterBank = () => {
  const [data, setData] = React.useState();
  const [isAdd, setIsAdd] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [selectedItemId, setSelectedItemId] = React.useState();

  const [renderKey, setRenderKey] = React.useState(0);
  const [globalFilters, setGlobalFilters] = React.useState();
  const [isButtonClicked, setIsButtonClicked] = React.useState();
  const [isDownloadClicked, setIsDownloadClicked] = React.useState();

  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  const { data: bankDatas, loading } = useApiNew(
    bankApiURL,
    "GET",
    { headers },
    renderKey,
  );

  const bankData = bankDatas?.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
  }));

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const downloadExcel = async (filename) => {
    try {
      const apiEndpoint = exportBankApiURL;
      const headers = {
        Authorization: `Bearer ${
          sessionStorage.getItem("subscriberToken")
            ? sessionStorage.getItem("subscriberToken")
            : sessionStorage.getItem("token")
        }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename here

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      errorNotify("Something went wrong.");
      setIsDownloadClicked(false);
    }
  };

  const filterBankData = () => {
    let filterData = bankData;
    if (globalFilters) {
      filterData = bankData.filter(
        (item) =>
          item?.name?.toLowerCase().includes(globalFilters?.toLowerCase()) ||
          item?.short_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.status?.toLowerCase() === globalFilters?.toLowerCase(),
      );
    }
    setData(filterData);
  };
  useEffect(() => {
    filterBankData();
  }, [globalFilters]);

  // ADD

  const handleAddBank = async (data) => {
    setIsButtonClicked(true);
    try {
      const res = await axios.post(bankApiURL, data, { headers });
      const resData = res.data;

      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // EDIT

  const handleEditBank = async (segmentId, data) => {
    setIsButtonClicked(true);
    const updateAPI = `${bankApiURL}/${segmentId}`;

    try {
      const res = await axios.put(updateAPI, data, { headers });
      const resData = res.data;

      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // DELETE

  const handleDeleteBank = async () => {
    const deleteAPI = `${bankApiURL}/${selectedItemId}`;
    try {
      const res = await axios.delete(deleteAPI, { headers });
      const resData = res.data;
      triggerRerender();
      if (!resData.error) {
        successNotify("Data deleted.");
        setIsDelete(false);
        return true;
      } else {
        errorNotify(resData?.message);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };

  const breadcrumbs = ["Home", "Master", "Bank"];

  // DOWNLOAD
  const handleDownloadBank = async () => {
    setIsDownloadClicked(true);
    const filename = `Bank-Master_${formattedDate}.xlsx`;
    downloadExcel(filename);
  };

  const buttonConfig = {
    value: "bank",
    name: "Bank",
    addHandler: handleAddBank,
    editHandler: handleEditBank,
    downloadHandler: handleDownloadBank,
    deleteHandler: handleDeleteBank,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
  };

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <MasterBankTable
        tableData={globalFilters ? data : bankData}
        loading={loading}
        bankDatas={bankDatas}
        buttonConfig={buttonConfig}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        setIsDelete={setIsDelete}
        setSelectedItemId={setSelectedItemId}
        renderKey={renderKey}
        setGlobalFilters={setGlobalFilters}
        actionPermissions={actionPermissions("masters", "Bank")}
        isDownloadClicked={isDownloadClicked}
      />
      {isAdd && (
        <MasterBankAdd
          buttonConfig={buttonConfig}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isEdit && (
        <MasterBankEdit
          buttonConfig={buttonConfig}
          selectedItemId={selectedItemId}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isDelete && (
        <DeleteAlert
          closeHandler={() => setIsDelete(false)}
          deleteHandler={buttonConfig.deleteHandler}
        />
      )}
    </div>
  );
};

export default MasterBank;
